<template>
  <focus-trap>
    <div
      tabindex="-1"
      class="modal d-block"
      @click.self="close"
      @keyup.esc="close"
    >
      <div class="modal-dialog modal-dialog-centered modal-557px">
        <div class="modal-content">
          <div
            ref="header"
            class="modal-header"
          >
            <h5 class="modal-title font-weight-bold">
              Accessibility Statement
            </h5>
            <button
              type="button"
              class="close"
              aria-label="close"
              @click="close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              TinyURL, LLC (the company) makes reasonable efforts to provide its
              employees and the public, including persons with disabilities,
              with access to the tinyurl.com website ("Website") and its related
              information and services. The Website has been designed to reach
              the widest audience possible, but, if you have difficulty viewing
              the Website, using the Website, or performing any transaction
              through the Website, you are encouraged to contact the Company at
              <a href="mailto:general@tinyurl.com">general@tinyurl.com</a>
              or by
              <router-link
                :to="{ name: 'freescout' }"
                target="_blank"
              >
                <span>opening a support ticket</span>
              </router-link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
</template>

<script>
export default {
  name: "ModalAccessibility",

  data: () => ({
    strictPrivate: false,
  }),

  watch: {
    strictPrivate() {
      this.$cookies.set(
        "tinyStrictPrivate",
        this.strictPrivate ? "true" : "false",
        Infinity,
      );
    },
  },

  created() {
    this.strictPrivate = this.$cookies.get("tinyStrictPrivate") === "true";
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.header.focus();
    });
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: underline !important;
}
</style>
